import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Portal from 'src/layout/Portal/Portal';
import moment from 'moment';
import { Grid } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import useEventListener from 'src/hooks/useEventListener';
import { TModalFullScreen, TModalSize } from 'src/type/modal-type';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import { BsXCircleFill } from 'react-icons/bs';

export default function ModalChangePass({
	isOpen,
	exit,
	oldPass,
	newPass,
	setOldPass,
	setNewPass,
	handleSubmit,
	t,
}) {
	return (
		<div>
			<Portal>
				<AnimatePresence mode='wait'>
					{isOpen && (
						<>
							<motion.div
								initial={{ scale: 0 }}
								animate={{ rotate: 0, scale: 1 }}
								transition={{
									type: 'spring',
									stiffness: 260,
									damping: 20,
								}}
								key='modal'
								className='modal show'
								style={{ display: 'block' }}
								tabIndex={-1}
								aria-hidden='true'>
								<div
									className='modal-dialog
                                modal-dialog-scrollable
                                modal-dialog-centered'>
									<div className='modal-content'>
										<div className='div_edit_bar'>
											<div className='fw-bold h5'>
												{t('txt_change_password')}
											</div>
											<div className='div_exit' onClick={() => exit()}>
												<BsXCircleFill
													style={{ width: '15px', height: 'auto' }}
												/>
											</div>
										</div>
										<hr style={{ margin: '0px 0px 1rem 0px' }} />
										<div className='div_edit_content'>
											<FormGroup label={t('txt_old_password')}>
												<Input
													name='oldpassword'
													placeholder=''
													className='input_search'
													type='password'
													value={oldPass}
													onChange={(e) => setOldPass(e.target.value)}
												/>
											</FormGroup>
											<FormGroup
												label={t('txt_new_password')}
												style={{ marginTop: '1rem' }}>
												<Input
													name='newpassword'
													placeholder=''
													className='input_search'
													type='password'
													value={newPass}
													onChange={(e) => setNewPass(e.target.value)}
												/>
											</FormGroup>
											<Button
												onClick={handleSubmit}
												className='btn_save_edit'>
												<span>{t('txt_save')}</span>
											</Button>
										</div>
									</div>
								</div>
							</motion.div>
							<div className='modal-backdrop show'></div>
						</>
					)}
				</AnimatePresence>
			</Portal>
		</div>
	);
}
